export default "__VITE_ASSET__a6ad08f0__"